module.exports = __webpack_public_path__ + "static/media/deleteFill.9aeb36c0.svg";